module.exports = __webpack_public_path__ + "img/back.cf338d6c.png";